<div class="ph-15">
  <p-table [showGridlines]="true"
    [value]="taskSearchResult?.Result"
    [paginator]="true"
    [rows]="searchParams ? searchParams.PageSize : 10"
    [lazy]="true"
    [totalRecords]="taskSearchResult?.TotalCount"
    (onLazyLoad)="lazyLoadTasks($event)"
    [loading]="loading"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="Descr">
          {{ 'tasks.search.description' | translate | ucfirst }}
          <p-sortIcon field="Descr"></p-sortIcon>
        </th>
        <th class="t-ac due-date" pSortableColumn="DateDue">
          {{ 'tasks.search.due-date' | translate | ucfirst }}
          <p-sortIcon field="DateDue"></p-sortIcon>
        </th>
        <th pSortableColumn="Profile.ReportName">
          {{ 'tasks.search.profile' | translate | ucfirst }}
          <p-sortIcon field="Profile.ReportName"></p-sortIcon>
        </th>
        <th class="assigned-to" pSortableColumn="AssignedToUserName">
          {{ 'tasks.search.assigned-to' | translate | ucfirst }}
          <p-sortIcon field="AssignedToUserName"></p-sortIcon>
        </th>
        <th class="task-type" pSortableColumn="TaskType">
          {{ 'tasks.search.task-type' | translate | titlecase }}
          <p-sortIcon field="TaskType"></p-sortIcon>
        </th>
        <th class="assigned-by" pSortableColumn="AssignedByUserName">
          {{ 'tasks.search.assigned-by' | translate | titlecase }}
          <p-sortIcon field="AssignedByUserName"></p-sortIcon>
        </th>
        <th class="wp-80" pSortableColumn="Closed">
          {{ 'tasks.search.done' | translate | titlecase }}
          <p-sortIcon field="Closed"></p-sortIcon>
        </th>
        <th *ngIf="profileTasksTabFullAccess" [style]="{ width: '120px' }"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-task>
      <tr>
        <td>
          {{ task.Descr }}
        </td>
        <td class="t-ac" [ngClass]="{ late: task.Late }">
          {{ task.DateDue | date: 'MM/dd/yyyy' }}
        </td>
        <td>({{ task.ProfileID }}) {{ task.ProfileReportName }}</td>
        <td>
          {{ task.AssignedToUserName }}
        </td>
        <td>
          {{ task.TaskType }}
        </td>
        <td>
          {{ task.AssignedByUserName }}
        </td>
        <td class="t-ac">
          <p-checkbox binary="true" [(ngModel)]="task.Closed" (onChange)="closedChanged(task)"></p-checkbox>
        </td>
        <td *ngIf="profileTasksTabFullAccess" class="tasks-actions-menu" style="padding: 0; text-align: center">
          <action-button [label]="'tasks.search.actions-label' | translate | uppercase" [items]="actionItemsForTask(task)"> </action-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div style="margin-top: -3.3em; float: left">
    <p-select [options]="pagingSizeItems" [(ngModel)]="searchParams.PageSize" (ngModelChange)="pageSizeChanged()" appendTo="body">
    </p-select>
  </div>
  <button pButton type="button" class="atlas-btn atlas-btn-primary" iconPos="right" (click)="exportTasks()" [disabled]="exportDisabled">
    {{ 'tasks.search.export-to-csv' | translate | uppercase }}
  </button>
</div>

<wl-task-edit-dialog (taskSaved)="search()"></wl-task-edit-dialog>

<p-confirmDialog #cd header="{{ 'tasks.search.delete-confirmation-header' | translate | titlecase }}" icon="pi pi-exclamation-triangle">
  <ng-template pTemplate="footer">
    <button type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button type="button" class="atlas-btn atlas-btn-primary" (click)="cd.onAccept()">
      {{ 'common.delete' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>
